// 별별책방 - 본사 - 지사별 사용량 메인 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";

import bookStyle from "../components/style";

import CardStatContent, { CardStatBranchContent } from "../components/CardStatContent";
import BranchContentList from "./BranchContentList";

const BranchContent = forwardRef(({ branchList, statPeriod, selectedSubOption = "콘텐츠 순 실행 수", updateViewSubOption, onViewSubOptionSelected }, ref) => {
    const [subOptionApplied, setSubOptionApplied] = useState(false);
    const [stat, setStat] = useState(false);
    const [branchCount, setBranchCount] = useState(0);
    const [totalCount, setTotalCount] = useState(false);
    const [totalCategory, setTotalCategory] = useState([0, 0, 0, 0, 0]);
    const [sortOption, setSortOption] = useState({ colId: "nurseryName", sort: "asc" });
    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            const excelData = {
                fileName: `별별책방(${selectedSubOption === "콘텐츠 순 실행 수" ? "순" : "누적"})통계`,
                sheets: [
                    {
                        name: "콘텐츠",
                        title: `별별책방 지사콘텐츠(${selectedSubOption === "콘텐츠 순 실행 수" ? "순" : "누적"}) 통계`,
                        columnTitle: ["지사", "집콕", "프리미엄동화", "기타 동화", "오디오북", "동요", "AR", "검색", "보관함", "홈", `(${selectedSubOption === "콘텐츠 순 실행 수" ? "순" : "누적"}) 실행 수`],
                        data: stat
                            ? stat.map((s) => [
                                  s.branchName,
                                  s.playCount1,
                                  s.playCount2,
                                  s.playCount3,
                                  s.playCount4,
                                  s.playCount5,
                                  s.playCount6,
                                  s.playCount7,
                                  s.playCount8,
                                  s.playCount9,
                                  s.totalCount,
                              ])
                            : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        setStat(false);
        if (selectedSubOption != "-") {
            axios({
                method: "POST",
                url: `/api/books_stat/book/branch/content`,
                data: {
                    startDate: statPeriod.startDate,
                    endDate: statPeriod.endDate,
                    periodType: statPeriod.type,
                    type: selectedSubOption,
                },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        var stat = [];
                        const playCount = result.data.data.branchContent;
                        const userCount = result.data.data.branchUser;
                        let totalCount = 0;
                        stat = playCount.map((ct) => {
                            totalCount += ct.totalCount;
                            var mergeNursery = userCount.find((con) => {
                                return ct.branchName == con.branchName;
                            });
                            if (mergeNursery) {
                                ct.cntUser = mergeNursery.countUser;
                            }

                            return ct;
                        });

                        setStat(stat);
                        setBranchCount(branchCount);
                        setTotalCount(totalCount);
                        setTotalCategory(totalCategory);
                    } else {
                        alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    }, [statPeriod, selectedSubOption]);
    useEffect(() => {
        if (!subOptionApplied && updateViewSubOption) {
            updateViewSubOption(
                [
                    { name: "콘텐츠 순 실행 수", id: "content" },
                    { name: "콘텐츠 누적 실행 수", id: "sum" },
                ],
                "콘텐츠 순 실행 수"
            );
            setSubOptionApplied(true);
        }
        getStat();
        return () => {};
    }, [getStat, subOptionApplied]);
    const series = bookStyle.seriesBookChart.map((s) => Object.assign({}, s));
    const chartOption = {
        xAxis: {
            field: "branchName",
            option: {
                axisLabel: {
                    show: true,
                    interval: 0,
                    rotate: 45,
                },
            },
        },
        yAxis: {
            name: "건",
            series: series,
        },
        stacks: [{ stack: "base", title: `별별책방 ${selectedSubOption === "콘텐츠 순 실행 수" ? "순" : "누적"} 실행 수`, showSum: false, showSumTooltip: true, showPercent: true }],
        showLegend: true,
        legend: {
            x: "right",
            y: "top",
        },
        sort: false,
        grid: {
            top: "10%",
            left: "5%",
            right: "5%",
            bottom: "15%",
        },
    };

    function onListSortChanged(colId, sort) {
        setSortOption({ sortOption: { colId, sort } });
    }

    const typeTitle = selectedSubOption === "콘텐츠 순 실행 수" ? "순" : "누적";
    const branchTop = stat && stat.length > 0 ? stat[0] : null;
    const branchLast = stat && stat.length > 0 ? stat[stat.length - 1] : null;

    return (
        <div className="stat-branch-content">
            <div className="row mb-2">
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <CardStatContent id="1" title={`전체 콘텐츠 ${typeTitle} 실행 수`} average = {isNaN((totalCount/stat.length).toFixed(3)) ? "0": (totalCount/stat.length).toFixed(3)} titleTotal="합계:" total={totalCount} titleBgClass="bg-tomonote" />
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                    <CardStatBranchContent id="4" top={branchTop} last={branchLast} />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="card">
                        <div className="card-body" style={{ height: "500px", textAlign: "center" }}>
                            <CommonHorizontalBarChart chartData={stat} chartOption={chartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <BranchContentList data={stat} onListSortChanged={onListSortChanged.bind(this)} />
                </div>
            </div>
        </div>
    );
});

export default BranchContent;
